module.exports = __webpack_public_path__ + "img/banner1.5a3c8107.jpg";